export default __webpack_public_path__ + "static/media/jorkata-avatar.270d43fa.jpg";